import { useQuery } from 'react-query';
import { POST, getRecaptchaToken } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';
import { userDataSet } from 'store/userData';
import { useDispatch } from 'react-redux';
export const Services = ({journeyGuid, lngCode, rcaEnabled, executeRecaptcha, useMock}) => {

    const baseApi = `${lngCode}`;
    const clientStateDataUpdate = useClientStateDataUpdate();
    const dispatch = useDispatch()
        return {
          useServicesQuery(hasRecaptcha, locationId, serviceTypeId, appointmentTypeId, customerGUID, journeyGUID, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict, userData, activeStep, beforeServiceQuestionsWithFilter, serviceEnabled) {
            return useQuery(['active-query', 'services', questionAnswerDict, locationId, serviceTypeId, appointmentTypeId],
              ({ queryKey }) => getServices(hasRecaptcha, locationId, serviceTypeId, appointmentTypeId, customerGUID, journeyGUID, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict, userData, activeStep, beforeServiceQuestionsWithFilter),
              { enabled: serviceEnabled }
            );
        }
    }

    async function getServices (hasRecaptcha, locationId, serviceTypeId, appointmentTypeId, customerGUID, journeyGUID, serviceId,calendarIds, selectedSlot, selectedDate, questionAnswerDict, userData, activeStep, beforeServiceQuestionsWithFilter) {
        if(useMock){
            return Promise.resolve(() =>
            {
              return [...Array(6).keys()].map(x=>{
                const id = ++x;
                return {
                    id,
                    name:`service ${id}`,
                    publicName:`service ${id}`,
                    locationName: `location ${id}`,
                  }
              })
            })
        }
        const clientStateData = {}

        if (locationId) clientStateData.unitId = locationId;
        if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
        if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
        if (customerGUID) clientStateData.customerGUID = customerGUID;
        if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;
        if (serviceId) clientStateData.serviceId = serviceId;
        if (calendarIds) clientStateData.calendarIds = calendarIds;
        if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
        if (selectedDate) clientStateData.selectedDate = selectedDate;
        const params = {}

        if (journeyGuid) params.journeyGUID = journeyGUID;
        if (lngCode) params.lngCode = lngCode;

        params.clientStateData = clientStateData ? clientStateData : null

        const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken( await executeRecaptcha('services') )) || {};

        const response = await POST(`${baseApi}/services/findservices`,  params, headers )

        if (response.clientStateData){ clientStateDataUpdate(response.clientStateData)}


        const dontShowQuestions = userData?.dont_show_question
        const currentStepQuestions = beforeServiceQuestionsWithFilter && beforeServiceQuestionsWithFilter
        const foundDontShowQuestions = findMatchingQuestions(dontShowQuestions, currentStepQuestions)

        if ((response && foundDontShowQuestions )|| (response && beforeServiceQuestionsWithFilter) ) {
            const { serviceId, ...otherProperties } = clientStateData;
            setTimeout(() => {
                dispatch(userDataSet({ service: null, clientStateData: { ...otherProperties, serviceId: null } }))
            },50 )
          }
      

        return response.services.map((service) => {
            return {
                id: service.serviceId,
                name: service.servicePublicName || service.serviceName,
                publicName: service.servicePublicName,
                locationName: service.unitName
            }
        })
    }

}


function findMatchingQuestions(currentStepQuestions, dontShowQuestions) {
    if (!currentStepQuestions || !dontShowQuestions) {
      return null;
    }
    const foundDontShowQuestions = Object.keys(currentStepQuestions)
      .filter(key => dontShowQuestions.hasOwnProperty(key)) 
      .reduce((acc, key) => {
        acc[key] = dontShowQuestions[key]; 
        return acc;
      }, {});
  
    return foundDontShowQuestions;
  }




